export const confirmAdminAction = (message, options = {}) =>
  new Promise((resolve) => {
    window.dispatchEvent(
      new CustomEvent('admin:confirm', { detail: { message, options, resolve } })
    );
  });
